import $ from 'jquery';

class ResearchSlider {
    constructor () {
        this.year1 = $('#year1');
        this.year2 = $('#year2');
        // this.year3 = $('#year3');
        this.events();
    }

    events(){

        this.year1.addClass('animate-large-text')

        this.year1.on('click', () => {
            var underline = document.getElementById("underline-dark");
            underline.style.transform = 'translateX(0px)';
            underline.style.transitionDuration = '0.3s';
            underline.style.transitionTimingFunction = 'ease-in-out';

        });

        this.year2.on('click', () => {
            var underline = document.getElementById("underline-dark");
            underline.style.transform = 'translateX(4.6em)';
            underline.style.transitionDuration = '0.3s';
            underline.style.transitionTimingFunction = 'ease-in-out';
        });

        // this.year3.on('click', () => {
        //     var underline = document.getElementById("underline-dark");
        //     underline.style.transform = 'translateX(9.4em)';
        //     underline.style.transitionDuration = '0.3s';
        //     underline.style.transitionTimingFunction = 'ease-in-out';

        // });

        var yearsContainer = document.getElementById('years')

        if(!yearsContainer) return;

        yearsContainer.addEventListener("click", function(evt) {
            let year1button = document.getElementById('year1'),
            targetEl = evt.target;  
            do {
            if(targetEl == year1button) {
                if(year1button.classList.contains('animate-small-text')){
                    year1button.classList.remove('animate-small-text')
                }
                year1button.classList.add('animate-large-text');
                return;
            }
            targetEl = targetEl.parentNode;
            } while (targetEl);
                if(year1button.classList.contains('animate-large-text')){
                    year1button.classList.add('animate-small-text')
                    year1button.classList.remove('animate-large-text')
                }
        });

        yearsContainer.addEventListener("click", function(evt) {
            let year2button = document.getElementById('year2'),
            targetEl = evt.target;  
            do {
            if(targetEl == year2button) {
                if(year2button.classList.contains('animate-small-text')){
                    year2button.classList.remove('animate-small-text')
                }
                year2button.classList.add('animate-large-text');
                return;
            }
            targetEl = targetEl.parentNode;
            } while (targetEl);
                if(year2button.classList.contains('animate-large-text')){
                    year2button.classList.add('animate-small-text')
                    year2button.classList.remove('animate-large-text')
                }
        });

        // yearsContainer.addEventListener("click", function(evt) {
        //     let year3button = document.getElementById('year3'),
        //     targetEl = evt.target;  
        //     do {
        //     if(targetEl == year3button) {
        //         if(year3button.classList.contains('animate-small-text')){
        //             year3button.classList.remove('animate-small-text')
        //         }
        //         year3button.classList.add('animate-large-text');
        //         return;
        //     }
        //     targetEl = targetEl.parentNode;
        //     } while (targetEl);
        //         if(year3button.classList.contains('animate-large-text')){
        //             year3button.classList.add('animate-small-text')
        //             year3button.classList.remove('animate-large-text')
        //         }
        // });
    }

}

export default ResearchSlider;
